// src/pages/SchemaDebugPage.js
import React, { useEffect, useState } from 'react';
import apiClient from '../api/client';

function SchemaDebugPage() {
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    apiClient.get('/debug/schema')
      .then(res => setData(res.data))
      .catch(err => setError(err));
  }, []);

  if (error) return <p>Error: {error.message}</p>;
  if (!data) return <p>Loading...</p>;

  return (
    <div>
      <h2>Schema Debug</h2>
      <pre>{JSON.stringify(data, null, 2)}</pre>
    </div>
  );
}

export default SchemaDebugPage;